import type { PortalFlag, PortalInvitation, SharedRecordVM, UploadSlot } from './types.js';
import { ACTIVE_VERTICAL } from '../config/verticals.js';

/** Seed data for an offline-interactive supplier portal (single hero deal). */

const V = ACTIVE_VERTICAL;

export const INVITATION: PortalInvitation = {
  id: 'inv_0xA31',
  invited_by: 'Lench Procurement',
  supplier: 'Medisource Trading FZE',
  deal: 'DEAL-4471 · infusion pumps, 40 units',
  vertical: V.vertical,
  asset_summary: 'Infusion pump, Class IIb',
  role: 'distributor',
  register_id: 'DED-901882',
  rows: [
    ['Buyer', 'Lench Procurement'],
    ['Deal', 'DEAL-4471'],
    ['Asset', 'Infusion pump, Class IIb · 40 units'],
    ['Your role', 'Distributor'],
    ['Scope', 'EU placement · MDR'],
    ['Tier granted', 'restricted'],
  ],
  status: 'pending',
};

export const UPLOAD_SLOTS: UploadSlot[] = [
  { key: 'cert', label: V.upload.document_labels[0] ?? 'Certificate', hint: 'PDF · parsed on receipt', required: true },
  { key: 'iso', label: V.upload.document_labels[1] ?? 'ISO certificate', hint: 'PDF', required: false },
  { key: 'serials', label: 'Serial / lot list', hint: 'CSV or PDF · per-unit', required: true },
  { key: 'doc', label: V.upload.document_labels[2] ?? 'Declaration of conformity', hint: 'PDF', required: false },
  { key: 'custody', label: 'Custody / shipping document', hint: 'Bill of lading, invoice', required: false },
];

export const FLAG: PortalFlag = {
  check: 'c6 · unit authenticity',
  flag_type: 'diversion_signal',
  severity: 'high',
  scope: 'unit',
  affected_units: ['SN0007', 'SN0012'],
  detail: 'Two serials in this consignment were last observed in a different custody chain.',
  ask: 'Confirm custody for the affected units or supply a manufacturer-callback attestation.',
};

export const SHARED_RECORD: SharedRecordVM = {
  record_id: 'rec_7K2P · v3',
  supplier: 'Medisource Trading FZE',
  state: 'clear_with_flags',
  depth_reached: 'unit_authentic',
  granted_tier: 'restricted',
  weakest: {
    check: 'c6',
    state: 'flag',
    text: 'Unit authenticity flagged for 2 of 40 serials — diversion signal, unit-scoped.',
  },
  checks: [
    { id: 'c1', number: 'c1_identity', name: 'Device identity resolves', state: 'verified_machine', depth: 'identity_authentic', source: 'EUDAMED', min_tier: 'public' },
    { id: 'c3', number: 'c3_classification', name: 'Classification lawful (Class IIb)', state: 'verified_machine', depth: 'type_lawful', source: 'rule-engine', min_tier: 'public' },
    { id: 'c4', number: 'c4_certificate', name: 'CE certificate valid (MDR)', state: 'verified_machine', depth: 'identity_authentic', source: 'NANDO', min_tier: 'restricted' },
    { id: 'e1', number: 'e1_entity', name: 'Manufacturer entity active', state: 'verified_machine', depth: 'identity_authentic', source: 'Companies House', min_tier: 'restricted' },
    { id: 'c6', number: 'c6_unit', name: 'Unit authenticity', state: 'flag', depth: 'unit_authentic', source: 'ledger', min_tier: 'restricted' },
    { id: 'e2', number: 'e2_ubo', name: 'Beneficial ownership control record', state: 'verified_attestation', depth: null, source: 'attestation', min_tier: 'authority' },
  ],
};
